<template>
  <div>
    <vx-breadcrumb :list="breadcrumbList" class="custom-bread-crumb" />
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <div @click="cancelEdit" class="vx-row cursor-pointer">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("Edit Ticket Task") }}</h4>
          </div>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card class="p-3">
        <form>
          <div class="vx-row">
            <div class="vx-col">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.category')"
                    >
                      <v-select
                        label="mCodeValue"
                        :options="ticketTemplates.problemsDatas"
                        :placeholder="$t('customers.label.SelectCategory')"
                        :reduce="(mCodeValue) => mCodeValue.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.problemCode"
                        disabled
                        @input="getSubCategory"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.mCodeValue
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.sub_category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.sub_category')"
                    >
                      <v-select
                        label="subCategory"
                        :options="subCategoryItem"
                        :placeholder="$t('customers.label.SelectSubCategory')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.subCategory"
                        disabled
                        :reduce="(subCategory) => subCategory.subCategory"
                        @input="setPriority"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.priority')"
                    >
                      <vs-input
                        :label="$t('customers.label.priority')"
                        v-model="ticket.priority"
                        class="w-full font-semibold mb-2 starlabel"
                        icon-no-border
                        disabled
                        :danger="false"
                        danger-text="wrong input"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full pb-5">
                  <vs-input
                    :label="$t('customers.label.ticket_date')"
                    class="w-full font-semibold starlabel"
                    disabled
                    v-model="ticket.ticketDate"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.source")
                    }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.sourceData"
                      disabled
                      :placeholder="$t('customers.label.SelectSource')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      v-model="ticket.sourceOfTicket"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.due_time")
                    }}</small>
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full"
                      disabled
                      v-model="ticket.dueTime"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.teamCode"
                        @input="getUserByTeam"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team_user")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team user"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.assignedTo"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("Reference")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="reference"
                      :key="resetKey"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.reference"
                        @input="onChangeReference"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("Reference Id")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="reference id"
                      :key="resetKey"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.referenceId"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
                <div class="vx-col sm:w-full lg:w-full md:w-full mt-4">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.comment")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.comment')"
                    >
                      <vs-textarea
                        class="w-full"
                        v-model="ticket.comment"
                        rows="4"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div style="height: 30px"></div>
                <div class="center mx-auto">
                  <span class="ml-1 mr-1">
                    <vs-button
                      type="border"
                      class="footerButton-next"
                      style="top: 0px"
                      @click="cancelEdit"
                      >{{ $t("Cancel") }}</vs-button
                    >
                  </span>
                  <span class="ml-1 mr-1">
                    <vs-button
                      @click="updateTicket"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("customers.label.submit") }}</vs-button
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import MultiFileUploader from "@/components/UploadMultipleFile.vue";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  // reference: null,
  // referenceId: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  comment: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: moment().format("HH:mm:ss A"),
};

export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        {
          name: "Ticket Task",
          path: `/customers/view_customer/${this.$route.params.id}/addticket/${this.$route.params.ticketId}`,
        },
        {
          name: "Edit Ticket Task",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      ticket: { ...ticketObj },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d m Y H:i:s",
      },
      bulkUploads: {
        files: null,
      },
      categoryId: null,
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    MultiFileUploader,
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      teamUsers: (state) => state.customer.teamUsers,
      ticketViewById: (state) => state.customerTicket.ticketViewById,
      ticketDocumentData: (state) => state.customerTicket.ticketDocumentData,
      ticketDetailsById: (state) => state.customerTicket.ticketDetailsById,
    }),
  },
  methods: {
    async getUserByTeam() {
      this.ticket.assignedTo = null;
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async onChangeReference() {
      this.ticket.referenceId = null;
      try {
        // this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTicketTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancelEdit() {
      if (this.$route.query.type == "customer") {
        this.$router.push("/customer_tickets");
      } else if (this.$route.query.type == "entity") {
        this.$router.push("/entity_tickets");
      } else {
        this.$router.push({
          path: `/customers/view_customer/${this.$route.params.id}/addticket/${this.$route.params.ticketId}`,
        });
      }
    },
    async updateTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        comments: this.ticket.comment,
        assignedTo: this.ticket.assignedTo,
        teamId: this.ticket.teamCode.toString(),
        teamUserId: this.ticket.assignedTo,
      };
      try {
        const data = {
          id: this.$route.params.subTaskId,
          data: payload,
        };
        await this.$store.dispatch("customerTicket/updateSubTicketAction", data);

        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Task Updated Successfully!",
          type: "success",
        });
        this.cancelEdit();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    setPriority(selectedSubCategory) {
      const subCategoryObj = this.subCategoryItem.find(
        (item) => item.subCategory === selectedSubCategory
      );
      this.ticket.priority = subCategoryObj.priority;
    },
    async getSubCategory(categoryId) {
      this.ticket.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.ticket.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    dateFormat(date) {
      const d = new Date(date);
      return moment(d).format("DD MMMM YYYY");
    },
    timeFormat(date) {
      return moment(date).format("HH:mm:ss");
    },
    async getTicketById() {
      try {
        // this.$store.dispatch(
        //   "customerTicket/setsTicketById",
        //   this.$route.params.ticketId
        // );
        await this.$store.dispatch(
          "customerTicket/getTicketDetailsByIdAction",
          {
            id: this.$route.params.ticketId,
          }
        );

        await this.getSubCategory(this.ticketDetailsById.problemCode);

        const d = new Date(this.ticketDetailsById.ticketDate);
        const TicketDate = moment(d).format("DD MM YYYY HH:mm:ss");

        this.ticket.assignedTo = this.ticketDetailsById.teamUserId;
        this.ticket.priority = this.ticketDetailsById.priority;
        this.ticket.problemCode = this.ticketDetailsById.problemCode;
        this.ticket.subCategory = this.ticketDetailsById.subCategorys;
        this.ticket.ticketDate = TicketDate;
        this.ticket.status = this.ticketDetailsById.status;
        this.ticket.dueTime = this.ticketDetailsById.dueDate;
        this.ticket.description = this.ticketDetailsById.description;
        this.ticket.sourceOfTicket = this.ticketDetailsById.sourceOfTicket;
        this.ticket.teamCode = Number(this.ticketDetailsById.teamCode);

        await this.$store.dispatch(
          "customer/getUserByTeam",
          this.ticket.teamCode
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "text-blue";
        case "REOPEN":
          return "text-yellow";
        case "CLOSED":
          return "text-green";
        case "Escalated":
          return "text-red";
        default:
          return "text-gray";
      }
    },
    getCardStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "border-blue";
        case "REOPEN":
          return "border-yellow";
        case "CLOSED":
          return "border-green";
        case "Escalated":
          return "border-red";
        default:
          return "border-gray";
      }
    },
    getPriorityClass(priority) {
      switch (priority) {
        case "HIGH":
          return "high-priority";
        case "MEDIUM":
          return "medium-priority";
        case "LOW":
          return "low-priority";
        default:
          return "";
      }
    },
  },
  watch: {},
  async mounted() {
    await this.getTicketTemplate();
    await this.getTicketById();
  },
};
</script>

<style scoped>
.flatpickr-calendar.open {
  z-index: 999999999999;
}
.ticket-el {
  border-top: 1px solid #ccc;
}
.view-container {
  background: #eee;
  height: 24rem;
  overflow-y: scroll;
  padding: 10px;
  border-radius: 8px;
}
.high-priority {
  color: red;
}

.medium-priority {
  color: orange;
}

.low-priority {
  color: green;
}
.text-blue {
  color: blue;
}
.text-yellow {
  color: rgb(224, 224, 27);
}
.text-red {
  color: red;
}
.text-green {
  color: green;
}
.text-gray {
  color: gray;
}
.border-blue {
  border: 2px solid blue;
  background-color: rgb(180, 180, 255);
}
.border-yellow {
  border: 2px solid rgb(224, 224, 27);
  background-color: rgb(255, 255, 200);
}
.border-red {
  border: 2px solid red;
  background-color: rgb(255, 177, 177);
}
.border-green {
  border: 2px solid green;
  background-color: rgb(200, 255, 200);
}
.border-gray {
  border: 2px solid gray;
}
.history-card ::v-deep .vx-card__body {
  padding: 12px !important;
}
</style>
